import { createSlice } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type IncognitoStatus = "active" | "inactive";

export type IncognitoInitialStateTypes = {
  status: IncognitoStatus;
};

const initialState: IncognitoInitialStateTypes = {
  status: "inactive",
};

export const incognitoSlice = createSlice({
  name: "incognitoSlice",
  initialState,
  reducers: {
    setActive: (state) => {
      state.status = "active";
    },
    setInactive: (state) => {
      state.status = "inactive";
    },
    toggleStatus: (state) => {
      state.status = state.status === "active" ? "inactive" : "active";
    },
  },
});

export const useIncognito = () => {
  const { status } = useAppSelector((state) => state.incognito);
  const dispatch = useAppDispatch();

  const activate = useCallback(() => {
    dispatch(setActive());
  }, [dispatch]);

  const deactivate = useCallback(() => {
    dispatch(setInactive());
  }, [dispatch]);

  const toggle = useCallback(() => {
    dispatch(toggleStatus());
  }, [dispatch]);

  const isActive = status === "active";

  return {
    status,
    isActive,
    activate,
    deactivate,
    toggle,
  };
};

export const { setActive, setInactive, toggleStatus } = incognitoSlice.actions;
export default incognitoSlice.reducer;
